/**
 * Default tooltip configuration properties for ReactTooltip.
 * @param text the text to display in the tooltip and for the aria-label attribute.
 */
export const tooltipAndLabel = (text?: string) => ({
    'aria-label': text,
    'data-tooltip-content': text,
    'data-tooltip-id': 'react-tooltip',
});
